export default __webpack_public_path__ + "static/media/3-6-3.13c120db.webp";